import SectionHeading from "../shared/SectionHeading";

const pricing = [
  {
    title: "Állapotfelmérés + kezelés",
    duration: "50 perc",
    price: "14 500 Ft",
  },
  { title: "Gyógytorna", duration: "50 perc", price: "14 500 Ft" },
  { title: "Manuálterápia", duration: "50 perc", price: "14 500 Ft" },
  { title: "Kinesio tape felhelyezés", duration: "20 perc", price: "7 000 Ft" },
  {
    title: "Gyógytorna + kinesio tape",
    duration: "50 perc",
    price: "14 500 Ft + anyagköltség",
  },
];

function PricingSection() {
  return (
    <section className="section section--soft" id="arak">
      <SectionHeading
        eyebrow="Árak"
        title="Átlátható kezelési díjak"
        centered
      />

      <div className="pricing-grid">
        {pricing.map((item) => (
          <article className="price-card" key={item.title}>
            <p className="price-card__title">{item.title}</p>
            <p className="price-card__duration">{item.duration}</p>
            <strong>{item.price}</strong>
          </article>
        ))}
      </div>
    </section>
  );
}

export default PricingSection;
